import React from "react";
import NavDropdown from "react-bootstrap/NavDropdown";
import { FaBell, FaPen, FaPowerOff, FaRegUser } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import pclogo from "../../Public/Images/pclogo.png";
import logo from "../../Public/Images/property-logo-new.png";

function Navbar(props) {
  const { Logout, isAuthenticated, userRole, userDetails } = useAuth();
 


  
  
  


  return (
    <>
      <header className="sticky-top">
        <nav
          id="navbar_top"
          className="navbar navbar-expand-lg navbar-dark header-top"
        >
          <div className="container-fluid">
            <Link
              className="navbar-brand d-none d-lg-block"
              to={
                userRole === undefined
                  ? ""
                  : userRole === "Owner" || userRole === "Partner"
                  ? "/dashboard"
                  : `/${userRole}dashboard`.toLowerCase()
              }
            >
              <img src={logo} alt="" />
            </Link>

            <Link
              className="navbar-brand d-block d-lg-none"
              to={
                userRole === undefined
                  ? ""
                  : userRole === "Owner" || userRole === "Partner"
                  ? "/dashboard"
                  : `/${userRole}dashboard`.toLowerCase()
              }
            >
              <img src={pclogo} alt="" />
            </Link>
            {isAuthenticated &&  (
              <>
               {userRole !== "Worker" && userRole !== "Tenant" && <button
                  className="rounded-circle p-2 sidebar_hamburger d-lg-none order-1 order-md-2 ms-2"
                  onClick={() => {
                    props.setIsSidebarOpen(!props.isSidebarOpen);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="habburger_icon"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>}

                <ul className=" ms-lg-auto d-flex align-items-center ms-auto ms-lg-0">
                  <li className="nav-item d-none d-lg-block">
                    <Link className="nav-link text-dark" to="#">
                      <FaBell className=" fs-4 m-0" />
                    </Link>
                  </li>

                  <NavDropdown
                    title={
                      userDetails?.profile_image ? (
                        <img
                        src={userDetails?.profile_image && userDetails?.profile_image?.url ?userDetails?.profile_image?.url :userDetails?.profile_image }
                          alt="error"
                          className="resize-none md:resize"
                        />
                      ) : (
                        `${userDetails?.logo_name}`
                      )
                    }
                    className={
                      !userDetails?.profile_image
                        ? "user-profile-link dropdown-toggle"
                        : "user-profile-link-image dropdown-toggle"
                    }
                  >
                    <div className="text-center profile-name-post">
                      <p className="mb-0 mt-2">
                        {userDetails &&
                          userDetails?.first_name +
                            " " +
                            userDetails?.last_name}
                      </p>
                      <span>
                        {userDetails?.Designation && userDetails?.Designation}
                      </span>
                    </div>

                    <NavDropdown.Item href="#action/3.2">
                      <Link
                        className="user-list d-flex align-items-center"
                        to="/personaldetails"
                      >
                        <FaRegUser className="user-i" /> Profile
                      </Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item>
                      <Link
                        className="user-list d-flex align-items-center"
                        to="/changepassword"
                      >
                        <FaPen className="user-i" />
                        Change Password
                      </Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={(e) => Logout(e)}>
                      <button className="user-list d-flex align-items-center">
                        <FaPowerOff className="user-i" />
                        Sign Out
                      </button>
                    </NavDropdown.Item>
                  </NavDropdown>
                </ul>
              </>
            )}
          </div>
        </nav>
      </header>
    </>
  );
}

export default React.memo(Navbar);
